/**
 * Get the text for a risk level from a category string
 * @param categoryLevel - The risk category string (e.g., "I", "II", "III", "IV")
 * @returns The text for the risk level
 */
export const getRiskLevelText = (categoryLevel: string): string => {
  if (!categoryLevel || categoryLevel === '0') return '--'
  return `Class ${categoryLevel}`
}
